{
	"app_name": "Topicus Events",
	"update": "Update",
	"update_later": "Later",
	"update_available": "Update beschikbaar",
	"update_available_description": "Er is een nieuwe versie van de Topicus Events app beschikbaar. Werk nu bij voor de beste ervaring.",
	"update_available_mandatory": "Verplichte update",
	"update_available_mandatory_description": "Je moet de Topicus Events app updaten om verder te gaan.",
	"update_available_version_text": "Je gebruikt nu versie {{currentVersion}}. Versie {{newVersion}} is beschikbaar.",
	"archive_default_title": "Archief",
	"archive_empty_message": "Je archief is nog leeg. Evenementen uit het verleden kun je hier straks terugvinden.",
	"archive_search_placeholder": "Zoeken naar evenementen",
	"archive_recent_events": "Recente evenementen",
	"archive_other_events": "Overige evenementen",
	"message_default_title": "Berichten",
	"message_empty_message": "Je hebt geen berichten. Berichten van door jou toegevoegde evenementen kun je hier vinden.",
	"message_web_only_title": "Alleen in de app",
	"message_web_only_message": "Berichten werken niet in een browser. Installeer de Topicus Events-app voor iOS of Android om ze te ontvangen.",
	"qr_web_only_title": "Alleen in de app",
	"qr_web_only_message": "Een QR-code scannen kan alleen in de app. Installeer de Topicus Events-app voor iOS of Android, of voeg het evenement toe met de code.",
	"message_search_placeholder": "Zoeken",
	"message_no_results_title": "Helaas...",
	"message_no_results": "geen resultaten gevonden",
	"error_default_subject": "Oeps, er is iets fout gegaan.",
	"error_default_message": "Probeer het later nog eens",
	"error_try_again": "Opnieuw proberen",
	"error_fetch_event": "Er is iets fout gegaan tijdens het ophalen van het event. Probeer het nogmaals.",
	"error_save_event": "Er is iets fout gegaan tijdens het opslaan van het event. Probeer het nogmaals.",
	"error_delete_event": "Er is iets fout gegaan tijdens het verwijderen van het event. Probeer het nogmaals.",
	"error_add_event": "Dit evenement bestaat niet of is nog niet gepubliceerd. Controleer de code bij de organisator",
	"error_add_event_failed": "Het evenement kon niet worden toegevoegd. Controleer je internetverbinding en probeer het opnieuw.",
	"error_event_not_found_title": "Evenement niet gevonden",
	"error_event_not_found_message": "Er is geen gepubliceerd evenement met deze code. Controleer de code, of vraag de organisator of het evenement al gepubliceerd is.",
	"error_favorite_toggle_failed": "Je like kon niet worden opgeslagen. Controleer je verbinding en probeer het opnieuw.",
	"error_favorites_load_failed": "We konden je favorieten niet ophalen. Ververs de lijst om ze opnieuw te laden.",
	"error_favorites_unavailable_title": "Likes niet beschikbaar",
	"error_favorites_refresh": "Ververs de lijst om de like-status op te halen, daarna kun je weer liken.",
	"error_event_in_list": "Je hebt dit evenement al toegevoegd. Je vindt het terug op je startscherm.",
	"error_image_load": "Afbeelding kon niet geladen worden",
	"error_link_open_title": "Kan niet openen",
	"error_link_open_message": "Dit kon niet geopend worden. Wil je het kopiëren?",
	"error_open_phone_title": "Telefoonnummer kan niet geopend worden",
	"error_open_email_title": "E-mailadres kan niet geopend worden",
	"error_open_link_title": "Link kan niet geopend worden",
	"error_open_value_message": "We konden {{value}} niet openen. Wil je het kopiëren?",
	"error_empty_email_subject": "Vul je e-mailadres in",
	"error_empty_email_message": "Om je wachtwoord te resetten moet je een geldig e-mailadres invoeren",
	"error_user_not_found_subject": "Gebruiker niet gevonden",
	"error_user_not_found_message": "Met het opgegeven e-mailadres is geen gebruiker gevonden",
	"error_invalid_credentials": "E-mailadres en/of wachtwoord is onjuist",
	"error_camera_permission": "Ga naar Instellingen > Topicus Events > Camera en geef de app toestemming om je camera te gebruiken",
	"error_camera_roll_permission_ios": "Ga naar Instellingen > Topicus Events > Foto's en geef de app toestemming tot je fotogalerij",
	"error_camera_roll_permission_android": "Ga naar Instellingen > Topicus Events > Opslag en geef de app toestemming om items op te slaan",
	"error_delete_event_offline": "Er moet internetverbinding zijn om een event te verwijderen.",
	"error_add_event_offline": "Er moet internetverbinding zijn om een event toe te voegen.",
	"error_empty_event_code": "Vul een event code in!",
	"error_something_went_wrong": "Er is iets misgegaan",
	"error_try_again_later": "Probeer het later opnieuw!",
	"cancel_deadline_passed_title": "Afmelden niet meer mogelijk",
	"cancel_deadline_passed_message": "De afmelddeadline is verstreken. Neem contact op met de organisatie om je af te melden.",
	"error_something_went_wrong_short": "Oeps",
	"error_something_went_wrong_generic": "Er is iets fout gegaan.",
	"notice_session_not_stored_title": "Je blijft ingelogd zolang dit venster openstaat",
	"notice_session_not_stored_embedded": "Deze browser bewaart geen gegevens in een venster dat in een andere site is ingesloten. Open de app in een eigen tabblad om ingelogd te blijven.",
	"notice_session_not_stored": "Deze browser bewaart geen gegevens, bijvoorbeeld in een privévenster. Sluit je de pagina, dan moet je opnieuw inloggen.",
	"error_session_expired_title": "Je bent uitgelogd",
	"error_session_expired": "Je sessie is verlopen. Log opnieuw in om verder te gaan.",
	"error_no_connection": "Geen verbinding met de server. Controleer je internet of probeer het later opnieuw.",
	"error_server": "Er ging iets mis op de server. Probeer het later opnieuw.",
	"error_went_wrong_title": "Er ging iets fout",
	"error_return_to_home": "Keer terug naar het hoofdmenu en probeer opnieuw",
	"error_password_too_short_title": "Wachtwoord te kort",
	"error_password_too_short_message": "Je wachtwoord moet minimaal 8 karakters bevatten.",
	"error_passwords_not_matching_title": "Oeps!",
	"error_passwords_not_matching_message": "Je wachtwoorden komen niet overeen. Probeer het nogmaals.",
	"error_passwords_not_matching_inline": "Je wachtwoorden komen niet overeen!",
	"error_invalid_email_inline": "Voer een geldig e-mail adres in.",
	"error_feedback_missing_title": "Je feedback ontbreekt!",
	"error_feedback_missing_message": "Vul tenminste het feedback veld in.",
	"error_empty_form": "Je kunt geen leeg formulier versturen",
	"error_required_fields": "Vul de verplichte velden in",
	"error_fill_field_above": "Vul het veld hierboven in",
	"error_field_required": "Dit veld is verplicht",
	"error_event_full_title": "Dit evenement is vol",
	"error_event_full_message": "Alle plaatsen zijn bezet, aanmelden is niet meer mogelijk.",
	"error_form_closed_title": "Helaas, dit formulier is gesloten",
	"error_form_closed_message": "Wil je nog een wijziging aanbrengen, je afmelden of juist nog aanmelden? Stuur dan een e-mail naar de organisatie met jouw verzoek.",
	"error_form_contact_note": "Neem contact op als dit niet gewenst is",
	"error_form_login_required": "Je moet aangemeld zijn om dit formulier in te vullen. Ga naar het beginscherm en log in of registreer je via de instellingen.",
	"error_form_needs_connection": "Je hebt een internetverbinding nodig om dit formulier in te vullen. Probeer het opnieuw zodra je weer online bent.",
	"error_form_load_failed": "Er is iets fout gegaan tijdens het laden van dit formulier. Probeer het opnieuw.",
	"error_login_required_for_event": "Voor dit evenement moet je inloggen. Log in om je aan te melden.",
	"error_email_exists_title": "E-mailadres al in gebruik",
	"error_email_exists_message": "Er bestaat al een account met dit e-mailadres. Log in, of herstel je wachtwoord als je het niet meer weet.",
	"error_fetch_gallery": "Er is iets fout gegaan tijdens het ophalen van deze galerij. Probeer het nogmaals.",
	"error_photo_permission_title": "Foto's kunnen niet worden gebruikt",
	"error_photo_permission_message": "Door het weigeren van deze permissie kunnen er geen foto's van je apparaat worden gebruikt.",
	"error_camera_not_available_title": "Camera kan niet worden gebruikt",
	"error_camera_not_available_message": "Door het weigeren van deze permissie kunnen er geen foto's worden gemaakt.",
	"success_saved_subject": "Opgeslagen!",
	"success_photo_saved": "De foto is toegevoegd aan je fotoalbum",
	"success_register_subject": "Registratie gelukt!",
	"success_register_message": "Bedankt voor je registratie!",
	"success_login_subject": "Top!",
	"success_login_message": "Je bent ingelogd!",
	"success_welcome_default": "Welkom Topicaan!",
	"success_welcome_named": "Welkom {{name}}!",
	"success_edit_profile_subject": "Profiel aangepast!",
	"success_edit_profile_message": "We hebben je profiel gewijzigd.",
	"success_password_reset_subject": "Wachtwoord gewijzigd!",
	"success_password_reset_message": "Log nu in met je nieuwe wachtwoord.",
	"success_password_forgot_subject": "Controleer je e-mail",
	"success_password_forgot_message": "Als er een account bestaat met dit e-mailadres, ontvang je een e-mail om je wachtwoord te herstellen.",
	"success_uploaded_title": "Geupload!",
	"success_uploaded_message": "De afbeelding is geupload!",
	"success_feedback_title": "Bedankt voor je feedback",
	"success_feedback_message": "We gaan er mee aan de slag!",
	"success_form_received_title": "Ontvangen",
	"success_form_received_message": "Het formulier is bij ons aangekomen!",
	"success_unsubscribed_title": "Gelukt",
	"success_unsubscribed_message": "Je bent afgemeld!",
	"success_password_changed": "Wachtwoord succesvol gewijzigd",
	"success_downloaded_title": "Gedownload",
	"success_downloaded_message_ios": "De afbeelding is gedownload en te vinden in je foto's.",
	"success_downloaded_message_android": "De afbeelding is gedownload en te vinden in je gallerij.",
	"success_downloaded_message_web": "De download is gestart. Je vindt de foto bij de downloads van je browser.",
	"label_first_name": "Voornaam",
	"label_last_name": "Achternaam",
	"label_email": "E-mailadres",
	"label_email_android": "Email adres",
	"label_password": "Wachtwoord",
	"label_password_repeat": "Wachtwoord herhalen",
	"label_new_password": "Nieuw wachtwoord",
	"label_new_password_repeat": "Herhaal nieuw wachtwoord",
	"label_your_name": "Je naam",
	"label_the_feedback": "De feedback",
	"label_video_player": "Video",
	"label_map": "Kaart",
	"placeholder_first_name": "Je voornaam",
	"placeholder_first_name_short": "Voornaam",
	"placeholder_last_name": "Je achternaam",
	"placeholder_last_name_short": "Achternaam",
	"placeholder_email": "Je email adres",
	"placeholder_email_short": "E-mailadres",
	"placeholder_email_android": "E-mail adres",
	"placeholder_password": "Het wachtwoord voor je account",
	"placeholder_password_min_chars": "Je wachtwoord, minimaal 8 karakters",
	"placeholder_password_repeat": "Herhaal het wachtwoord voor je account",
	"placeholder_password_short": "Wachtwoord",
	"placeholder_password_repeat_short": "Wachtwoord herhalen",
	"placeholder_your_name": "Je naam",
	"placeholder_feedback": "Je feedback",
	"placeholder_feedback_short": "Feedback",
	"placeholder_choose_option": "Kies een optie",
	"placeholder_search": "Zoeken",
	"placeholder_event_code": "Toegangscode voor het evenement",
	"button_login": "Inloggen",
	"button_register": "Registreren",
	"button_register_lower": "registreren",
	"button_save": "Opslaan",
	"button_submit": "Versturen",
	"button_change_password": "Wijzig wachtwoord",
	"button_forgot_password": "Wachtwoord vergeten?",
	"button_maybe_later": "Misschien later",
	"button_send_email": "Stuur email",
	"button_cancel": "Annuleren",
	"button_continue": "Doorgaan",
	"button_open": "Openen",
	"button_view_program_part": "Bekijk programmaonderdeel",
	"label_choice_info": "Info",
	"button_favorite": "Favoriet",
	"button_program_view_list": "Lijst",
	"button_program_view_blocks": "Blokkenschema",
	"text_participants_of": "{{taken}} / {{limit}} deelnemers",
	"error_too_many_attempts": "Je hebt het net te vaak geprobeerd. Wacht een minuut en probeer het opnieuw.",
	"text_choice_not_possible": "Dit kan niet samen",
	"text_max_choices": "Je mag maximaal {{count}} keuzes maken. Haal er eerst een weg.",
	"text_day_full": "Je mag voor {{day}} {{count}} keuze(s) maken. Haal er eerst een weg.",
	"text_overlaps": "Deze sessie is tegelijk met {{other}}, dus je kunt er maar één van kiezen.",
	"text_choice_full": "Vol",
	"text_seats_left_one": "Nog 1 plaats",
	"text_seats_left_other": "Nog {{count}} plaatsen",
	"maps_open_title": "Google Maps openen",
	"maps_open_message": "Je verlaat de app om deze locatie in Google Maps te openen.",
	"maps_choose_message": "Je verlaat de app om deze locatie te openen. Kies waarin je de route wilt bekijken.",
	"button_ok": "OK",
	"button_oke": "Oke",
	"button_copy": "Kopiëren",
	"button_save_changes": "WIJZIGINGEN OPSLAAN",
	"button_submit_upper": "VERSTUREN",
	"button_cancel_upper": "ANNULEREN",
	"button_add_upper": "TOEVOEGEN",
	"button_navigate_location_upper": "NAVIGEER NAAR LOCATIE",
	"button_add": "Toevoegen",
	"button_delete_upper": "VERWIJDEREN",
	"button_cancel_delete_upper": "ANNULEREN",
	"tab_home": "Home",
	"tab_archive": "Archief",
	"tab_messages": "Berichten",
	"tab_photos": "Foto's",
	"tab_settings": "Instellingen",
	"title_settings": "Instellingen",
	"title_login_or_register": "Inloggen of registreren",
	"title_welcome": "Welkom",
	"title_feedback": "Feedback geven",
	"title_contact": "Contact",
	"title_profile": "Profiel",
	"title_edit_profile": "Profielgegevens wijzigen",
	"title_forgot_password": "Wachtwoord vergeten",
	"title_change_password": "Wachtwoord wijzigen",
	"title_register": "Registreren",
	"title_qr_scanner": "Qr code scannen",
	"title_photos": "Foto's",
	"title_form_closed": "Formulier gesloten",
	"title_my_timetable": "Mijn persoonlijke programma",
	"text_login_description": "Met een gebruikersaccount worden evenementen aan jouw account gekoppeld. Hierdoor heb je altijd toegang tot je favoriete evenementen!",
	"text_change_password_description": "Kies een nieuw wachtwoord van minimaal 8 tekens.",
	"text_email_not_editable": "Je e-mailadres kan niet gewijzigd worden.",
	"text_email_from_account": "Dit is het e-mailadres van je account. Je bevestiging met QR-code gaat naar dit adres.",
	"text_no_internet": "Je hebt geen internetverbinding. Bepaalde functies van de app werken hierdoor mogelijk niet goed.",
	"text_scan_qr_instruction": "Richt je camera op de QR-code van het evenement",
	"text_form_login_description": "Voor dit formulier is een gebruikersaccount nodig. Aan jouw nieuwe Topicus Events account kunnen wij gegevens als toegangstickets koppelen, zodat jij jouw entreebewijs altijd bij de hand hebt!",
	"text_forgot_password_description": "Geen probleem. Vul je e-mail adres in en we sturen je instructies zodat je het wachtwoord kan herstellen.",
	"text_home_has_events": "Tik op een evenement om deze te openen.",
	"text_home_no_events": "Je hebt nog geen Topicus evenement toegevoegd. Druk op evenement toevoegen, scan of vul de code in om toegang te krijgen.",
	"text_add_event": "Evenement toevoegen",
	"text_no_photos_title": "Geen foto's beschikbaar",
	"text_no_photos_message": "Voeg een evenement toe om bijbehorende foto's te bekijken.",
	"text_gallery_empty": "Deze galerij bevat nog geen afbeeldingen.",
	"text_feedback_helper": "Met behulp van jouw feedback kunnen we de app verbeteren. Mochten we meer uitleg over de feedback nodig hebben, dan kunnen we contact met je opnemen.",
	"text_profile_subtitle": "Wijzig je profielgegevens",
	"text_receive_notifications": "Notificaties ontvangen",
	"text_receive_notifications_helper": "Ontvang pushmeldingen over wijzigingen en nieuws van je evenementen.",
	"text_give_feedback": "Feedback geven",
	"text_version_number": "Versienummer",
	"text_privacy_policy": "Privacybeleid",
	"url_privacy_policy": "https://topicusevents.nl/privacy-statement",
	"url_topicus": "https://www.topicus.nl",
	"text_contact_topicus": "Topicus",
	"text_contact_address": "Singel 25",
	"text_contact_postal": "7400 AH Deventer",
	"text_set_profile_photo": "Profielfoto instellen",
	"text_choose_profile_photo": "Profielfoto kiezen",
	"text_upload_photo": "Foto uploaden",
	"text_galleries": "Gallerijen",
	"text_hindered_question": "Ben je verhinderd? ",
	"text_unsubscribe": "Afmelden",
	"text_delete_account": "Verwijder account",
	"alert_access_event_title": "Toegang tot het evenement",
	"alert_access_event_message": "Voor toegang tot het evenement moet een QR code gelezen worden of moet een code handmatig ingevuld worden.",
	"alert_login_required_title": "Inloggen vereist",
	"alert_login_required_message": "Log in om een evenement toe te voegen. Zo blijft je deelname gekoppeld aan je account.",
	"alert_login_required_view_message": "Log in om dit evenement te bekijken. Zo blijft je deelname gekoppeld aan je account.",
	"alert_event_already_added_title": "Evenement al toegevoegd",
	"alert_scan_qr": "QR scannen",
	"alert_enter_code": "Code invullen",
	"alert_event_code_title": "Code voor het evenement",
	"alert_event_code_message": "Vul de code in om toegang te krijgen.",
	"alert_add_event_title": "Evenement toevoegen",
	"alert_add_event_description": "Voer de toegangscode van het event in om het evenement toe te voegen.",
	"alert_add_event_confirm_message": "Je staat op het punt dit evenement toe te voegen. Wil je doorgaan?",
	"alert_add_photo_title": "Foto toevoegen",
	"alert_add_photo_message": "Hiermee voeg je een foto toe aan {{name}}",
	"alert_open_camera": "Open camera",
	"alert_open_camera_roll": "Open filmrol",
	"alert_logout_title": "Uitloggen",
	"alert_logout_message": "Weet je zeker dat je wilt uitloggen?",
	"alert_logged_out_title": "Uitgelogd",
	"alert_logged_out_message": "Je bent uitgelogd omdat je je wachtwoord recentelijk gewijzigd hebt.",
	"alert_delete_account_title": "Account verwijderen",
	"alert_delete_account_message": "Je staat op het punt je account te verwijderen. Wil je doorgaan?",
	"alert_delete_account_confirm": "Verwijder",
	"alert_delete_account_final_title": "Weet je het zeker?",
	"alert_delete_account_final_message": "Dit kan niet worden teruggedraaid. Je account en gegevens worden definitief verwijderd.",
	"alert_account_deleted_title": "Account verwijderd",
	"alert_account_deleted_message": "Je account is verwijderd.",
	"alert_delete_event_title": "Evenement verwijderen?",
	"alert_delete_event_message": "Het verwijderen van een evenement kan niet ongedaan gemaakt worden. Weet je zeker dat je het wil verwijderen?",
	"alert_unsubscribe_title": "Afmelden",
	"alert_unsubscribe_message": "Weet je zeker dat je je wilt afmelden?",
	"alert_new_notification": "Nieuwe notificatie",
	"button_delete": "Verwijderen",
	"button_close": "Sluiten",
	"button_edit": "Wijzigen",
	"button_done": "Klaar",
	"title_subscribe": "Inschrijven",
	"text_have_account": "Heb je al een account? ",
	"text_no_account": "Nog geen account? ",
	"text_register_link": "Registreer",
	"day_sunday": "Zondag",
	"day_monday": "Maandag",
	"day_tuesday": "Dinsdag",
	"day_wednesday": "Woensdag",
	"day_thursday": "Donderdag",
	"day_friday": "Vrijdag",
	"day_saturday": "Zaterdag",
	"day_unknown": "Onbekend",
	"title_news": "Nieuwsberichten",
	"title_choose_gallery": "Galerij kiezen",
	"text_choose_gallery_description": "Klik op één van de onderstaande galerijen om een foto te uploaden naar deze galerij.",
	"text_no_favorites_for_day": "Op deze dag heb je geen favorieten.",
	"text_no_activities_in_timetable": "Er staan nog geen activiteiten in je persoonlijke timetable. Tik op het hartje naast de naam van een activiteit om hem aan jouw timetable toe te voegen.",
	"text_no_gallery_data": "Geen galerij data beschikbaar",
	"text_extra_information": "Extra Informatie",
	"text_no_results_found": "Geen resultaten gevonden.",
	"text_no_news_title": "Geen nieuws",
	"text_no_news_message": "Er is nog geen nieuws geplaatst.",
	"text_no_food_title": "Geen aanbod",
	"text_no_food_message": "Er is nog geen eten- en drinkenaanbod toegevoegd.",
	"text_no_locations_title": "Geen locaties",
	"text_no_locations_message": "Er zijn nog geen locaties toegevoegd.",
	"text_no_program_title": "Geen programma",
	"text_no_program_message": "Er is nog geen programma beschikbaar.",
	"text_no_timetable_title": "Geen timetable",
	"text_no_timetable_message": "Er is nog geen timetable beschikbaar.",
	"text_no_galleries_title": "Geen galerijen",
	"text_no_galleries_message": "Er zijn nog geen galerijen beschikbaar.",
	"text_no_content_title": "Geen inhoud",
	"text_no_content_message": "Deze pagina heeft nog geen inhoud.",
	"text_no_map_title": "Geen plattegrond",
	"text_no_map_message": "Er is nog geen plattegrond beschikbaar.",
	"text_error_prefix": "Foutmelding",
	"button_back": "Terug",
	"title_my_submission": "Mijn aanmelding",
	"title_programs": "Programma's",
	"title_day_number": "Dag {{number}}",
	"my_submission_banner_title": "Mijn aanmelding",
	"my_submission_banner_subtitle": "Bekijk je QR-code voor bij de ingang",
	"my_submission_helper": "Toon deze QR-code bij de ingang.",
	"my_submission_registration_label": "Registratienummer",
	"my_submission_programme_title": "Jouw programma",
	"my_submission_empty_title": "Geen aanmelding",
	"my_submission_empty_message": "Je hebt geen aanmelding voor dit evenement.",
	"my_submission_error_title": "Er ging iets mis",
	"my_submission_error_message": "We konden je aanmelding niet laden. Probeer het later opnieuw.",
	"on_behalf_question": "Voor wie is deze aanmelding?",
	"on_behalf_self": "Ik meld mezelf aan",
	"on_behalf_other": "Ik meld iemand anders aan",
	"on_behalf_logged_in_as": "Ingelogd als {{name}} ({{email}})",
	"on_behalf_email_hint": "De bevestiging met QR-code gaat naar het e-mailadres dat je hieronder invult.",
	"on_behalf_success_message": "De aanmelding is verstuurd naar {{email}}.",
	"on_behalf_list_title": "Door jou aangemeld",
	"on_behalf_cancel_message": "Weet je zeker dat je {{name}} wilt afmelden? {{name}} krijgt hiervan een bevestiging.",
	"on_behalf_cancelled_message": "{{name}} is afgemeld."
}
